import { getCartKey } from './cart';
import WOOCOMMERCE_URL from './client';

const BASE_URL: string = WOOCOMMERCE_URL;

/**
 * Pobiera URL do kasy WooCommerce (gość — z parametrem cocart-load-cart,
 * dzięki któremu klasyczna kasa wczytuje koszyk założony w Reakcie).
 */
export const getCheckoutUrl = (): string => {
    const cartKey = getCartKey();

    if (!cartKey) {
        throw new Error('Brak cart_key - koszyk jest pusty lub nie zainicjowany');
    }

    const baseUrl: string = (BASE_URL || '').replace(/\/$/, '');

    const checkoutUrl = `${baseUrl}/index.php/koszyk/?cocart-load-cart=${encodeURIComponent(cartKey)}`;

    return checkoutUrl;
};

/**
 * Pobiera URL do kasy WooCommerce dla ZALOGOWANEGO użytkownika.
 * Bez parametru cocart-load-cart — CoCart samo rozpoznaje zalogowanego
 * użytkownika po sesji/nonce, więc przekazywanie cart_key w URL nie jest
 * potrzebne. (Wykorzystywane od kroku 4 — logowanie SSO.)
 */
export const getCheckoutUrlForLoggedInUser = (): string => {
    const baseUrl: string = (BASE_URL || '').replace(/\/$/, '');

    const checkoutUrl = `${baseUrl}/index.php/zamowienie/`;

    return checkoutUrl;
};

/**
 * Sprawdza, czy koszyk nie jest pusty.
 */
export const validateCartBeforeCheckout = async (): Promise<{ valid: boolean; message?: string }> => {
    try {
        const cartKey = getCartKey();

        if (!cartKey) {
            return { valid: false, message: 'Koszyk jest pusty' };
        }

        return { valid: true };
    } catch (error) {
        console.error('❌ Błąd walidacji koszyka:', error);
        return { valid: false, message: 'Nie udało się zweryfikować koszyka' };
    }
};
